import API from '../../services/API'
import {
    PETS_GETTER,
    PETS_GETTER_PET_BY_ID,
    PETS_MUTATION_ENTIRE_PETS,
    PETS_MUTATION_SINGLE_PET,
    PETS_MUTATION_SINGLE_PET_ATTRIBUTE,
    PETS_MUTATION_DELETE_PET,
    PETS_MUTATION_ADD_PET,
    PETS_ACTION_GET_PETS,
    PETS_ACTION_CREATE_PET,
    PETS_ACTION_DELETE_PET,
    PETS_ACTION_UPDATE_PET
} from './pets-types'
import OAlert from '../../utils/OAlert/OAlert'
import i18n from '../../assets/i18n/lang'
import Vue from 'vue'

export default {
    namespaced: true,

    state: {
        pets: []
    },

    getters: {
        [PETS_GETTER]: state => state.pets,
        [PETS_GETTER_PET_BY_ID]: (state) => (id) => {
            return state.pets.find(pet => pet.id === id)
        }
    },

    mutations: {
        [PETS_MUTATION_ENTIRE_PETS] (state, payload) {
            state.pets = payload
            for (let i = 0; i < state.pets.length; i++) {
                if (state.pets[i]['birthdate'] != null) state.pets[i]['birthdate'] = new Date(state.pets[i]['birthdate'] + 'T00:00:00Z')
            }
        },
        [PETS_MUTATION_SINGLE_PET] (state, payload) {
            for (let i = 0; i < state.pets.length; i++) {
                if (state.pets[i].id === payload.id) {
                    Vue.set(state.pets, i, payload)
                }
            }
        },
        [PETS_MUTATION_SINGLE_PET_ATTRIBUTE] (state, payload) {
            let pet = state.pets.find(pet => pet.id === payload.id)
            let key = Object.keys(payload)[1]
            Vue.set(pet, key, payload[key])
        },
        [PETS_MUTATION_DELETE_PET] (state, payload) {
            for (let i = 0; i < state.pets.length; i++) {
                if (state.pets[i].id === payload) {
                    state.pets.splice(i, 1)
                }
            }
        },
        [PETS_MUTATION_ADD_PET] (state, payload) {
            Vue.set(state.pets, state.pets.length, payload)
        }
    },

    actions: {
        [PETS_ACTION_GET_PETS] ({ commit }) {
            return new Promise(
                function (resolve, reject) {
                    API.loadPets()
                        .then((petsData) => {
                            commit(PETS_MUTATION_ENTIRE_PETS, petsData.pets)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [PETS_ACTION_CREATE_PET] ({ commit }, payload) {
            return new Promise(
                function (resolve, reject) {
                    API.createPet(payload)
                        .then((petData) => {
                            OAlert.showSuccess('', i18n.t('feedback.petSucAdd'))
                            commit(PETS_MUTATION_ADD_PET, petData)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [PETS_ACTION_DELETE_PET] ({commit, state}, payload) {
            API.deletePet(payload)
                .then(() => {
                    OAlert.showSuccess('', i18n.t('feedback.petSucDelete'))
                    commit(PETS_MUTATION_DELETE_PET, payload)
                })
                .catch((error) => console.log(error.message))
        },
        [PETS_ACTION_UPDATE_PET] ({commit, state}, payload) {
            API.savePet(payload)
                .then((petData) => {
                    OAlert.showSuccess('', i18n.t('feedback.petSucSave'))
                    commit(PETS_MUTATION_SINGLE_PET, petData)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/pets.js